import './Hero.css';
import { useState, useEffect } from 'react';

const Hero = () => {
  useEffect(() => {
    // Optional: Any other mount logic can go here
  }, []);

  return (
    <section className="hero-section">
      <div
        className="hero-video-background w-background-video w-background-video-atom"
        data-poster-url="https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29%2F6880cb1cd4d7a23ab8bb196d_timmersvideo-poster-00001.jpg"
        data-video-urls="https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29%2F6880cb1cd4d7a23ab8bb196d_timmersvideo-transcode.mp4,https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29%2F6880cb1cd4d7a23ab8bb196d_timmersvideo-transcode.webm"
        data-autoplay="true"
        data-loop="true"
        data-wf-ignore="true"
      >
        <video
          id="hero-video"
          autoPlay
          loop
          muted
          playsInline
          style={{
            backgroundImage: 'url("https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29%2F6880cb1cd4d7a23ab8bb196d_timmersvideo-poster-00001.jpg")'
          }}
          data-wf-ignore="true"
          data-object-fit="cover"
        >
          <source
            src="https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29%2F6880cb1cd4d7a23ab8bb196d_timmersvideo-transcode.mp4"
            data-wf-ignore="true"
          />
          <source
            src="https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29%2F6880cb1cd4d7a23ab8bb196d_timmersvideo-transcode.webm"
            data-wf-ignore="true"
          />
        </video>
      </div>
      
      <div className="div-block-242"></div>
      
      <div className="container">
        <div className="hero-text-block">
          <div className="sub-text">gespecialiseerd in glastoepassingen</div>
          <h1 className="h1">Glas, glasbeslag en glasartikelen</h1>
          <div className="paragraph big-copy">
            Timmers BV is een groothandel in glas, glasbeslag en
            beglazingsmaterialen gevestigd in Oosterhout (NB). Wij zijn
            gespecialiseerd in glastoepassingen gecombineerd met glasbeslag en de
            toelevering van alle verwerkingsmaterialen voor de glaswereld.
          </div>

          <div className="button-block big">
            <a href="/webshop/products" className="button w-button">
              Bekijk ons assortiment
            </a>
          </div>
        </div>
      </div>
      
      <div className="div-block-244">
        <div className="container">
          <div className="w-layout-grid grid-3-columns">
            <div className="div-block-248">
              <img
                src="https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/689361116822f780018fc37c_local_shipping_24dp_FFFFFF_FILL0_wght400_GRAD0_opsz24.svg"
                loading="lazy"
                alt="Transport icon"
                className="image-9"
              />
              <div className="text-block-6">Eigen transport</div>
              <div className="text-block-7">
                Onze eigen transportdienst garandeert snelle en betrouwbare levering
                van al uw glasproducten.
              </div>
            </div>
            <div className="div-block-248">
              <img
                src="https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/6893607121110af7d3a98c38_tabler-file-invoice-line.svg"
                loading="lazy"
                alt="Invoice icon"
                className="image-9"
              />
              <div className="text-block-6">Betaling op factuur</div>
              <div className="text-block-7">
                Geniet van eenvoudige en flexibele betalingsopties die zijn
                afgestemd op al uw glasbehoeften.
              </div>
            </div>
            <div className="div-block-248">
              <img
                src="https://cdn.prod.website-files.com/6880c5a43590eb0405ce3a29/68936071a75d3b8e4d4228e1_remix-price-tag-3-line.svg"
                loading="lazy"
                alt="Price tag icon"
                className="image-9"
              />
              <div className="text-block-6">Scherpe prijzen</div>
              <div className="text-block-7">
                Concurrerende prijzen zonder concessies te doen aan de kwaliteit van
                onze producten.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
